import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { WebsocketProvider } from '../interfaces/websocket-provider.interface';
import { ConnectionData } from '../providers/web-socket-connection.provider';

@Injectable({providedIn: 'root'})
export class TestingWebsocketService implements WebsocketProvider {
  public config!: ConnectionData;

  setConfig(connectionData: ConnectionData): void {
    this.config = connectionData;
  }

  disconnect(): void {
  }

  initialize(): void {
  }

  listenForEvent<T = any>(channel: string, event: string, privateChannel: boolean): Observable<T> {
    return of({ event: 'workflow.test' } as any);
  }

  observeEvent<T = any>(channel: string, event: string, privateChannel: boolean): Observable<T> {
    return of({ event: 'workflow.test' } as any);
  }

  listenGlobal<T = any>(channel: string, privateChannel: boolean): Observable<T> {
    return of({ event: 'workflow.test' } as any);
  }
}
